var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropDownLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61523 0.204834C0.927734 0.204834 0.583984 1.01733 1.08398 1.48608L4.80273 5.20483C5.08398 5.51733 5.55273 5.51733 5.86523 5.20483L9.58398 1.48608C10.0527 1.01733 9.70898 0.204834 9.05273 0.204834H1.61523Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownLight);
export default __webpack_public_path__ + "static/media/drop-down-light.5dcffacbdfe433e70387f8cbe04cc150.svg";
export { ForwardRef as ReactComponent };